if (!customElements.get('product-sale-countdown')) {
  customElements.define('product-sale-countdown', class extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      this.start = Date.parse('2026-10-12T00:00:00+02:00');
      this.end = Date.parse('2026-10-19T00:00:00+02:00');
      this.serverNow = Number(this.dataset.serverNow) * 1000;
      this.clockStart = Date.now();
      this.monotonicStart = performance.now();
      this.form = this.closest('form');
      this.offers = Array.from(this.querySelectorAll('[data-sale-variant]'));
      this.refresh = () => this.update();
      this.form?.addEventListener('change', this.refresh);
      this.observer = new MutationObserver(this.refresh);
      if (this.form) this.observer.observe(this.form, {childList: true, subtree: true, attributes: true, attributeFilter: ['value']});
      this.update();
      if (!this.expired) this.interval = setInterval(this.refresh, 1000);
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.refresh);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
      this.form?.removeEventListener('change', this.refresh);
      this.observer?.disconnect();
    }
    update() {
      const elapsed = Math.max(Date.now() - this.clockStart, performance.now() - this.monotonicStart, 0);
      const now = this.serverNow + elapsed;
      if (this.expired || !Number.isFinite(now) || this.serverNow <= 0 || now >= this.end) {
        this.hidden = true;
        this.expired = true;
        clearInterval(this.interval);
        return;
      }
      if (now < this.start) { this.hidden = true; return; }
      const variantId = this.form?.querySelector('[name="id"]')?.value;
      const activeOffer = this.offers.find(offer => offer.dataset.saleVariant === variantId);
      for (const offer of this.offers) offer.hidden = offer !== activeOffer;
      if (!activeOffer) { this.hidden = true; return; }
      const seconds = Math.max(0, Math.floor((this.end - now) / 1000));
      if (seconds === 0) { this.hidden = true; return; }
      const units = {days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60};
      for (const [unit, value] of Object.entries(units)) {
        const node = this.querySelector(`[data-${unit}]`);
        const text = String(value).padStart(2, '0');
        if (node.textContent !== text) node.textContent = text;
      }
      this.hidden = false;
    }
  });
}
